import { Route } from 'react-router-dom'
import Acciones from '../pages/paquetes/Acciones'
import Secciones from '../pages/paquetes/Secciones'
import Paquetes from '../pages/paquetes/Paquetes'
import ProtectedRoute from '../components/ProtectedRoute'


const MaestrosRoutes = () => (
  <>
    <Route path="/paquetes" >
      <Route
        path="acciones"
        element={
          <ProtectedRoute requiredModule="maestros">
            <Acciones />
          </ProtectedRoute>
        }
      />
      <Route
        path="secciones"
        element={
          <ProtectedRoute requiredModule="maestros">
            <Secciones />
          </ProtectedRoute>
        }
      />
      <Route
        path="paquetes"
        element={
          <ProtectedRoute requiredModule="maestros">
            <Paquetes />
          </ProtectedRoute>
        }
      />
      {/* Puedes agregar más rutas de tablas maestras aquí */}
    </Route>
  </>
)

export default MaestrosRoutes
